import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const displayFaqs = faqs.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm">
            关于www91访问和使用的常见问题解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {displayFaqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-sm text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 w-5 h-5 flex items-center justify-center transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-secondary-100 text-secondary-700 hover:bg-secondary-200 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center"></i>
            查看更多问题
          </Link>
        </div>
      </div>
    </section>
  );
}